import React from 'react'
import { Grid } from '@material-ui/core'

import { useStyles } from './styles'
import SummaryCard from './SummaryCard'
import { getTextCardSummaryColor } from '../../../utils/productionPanel'
import { changeFormatNumbersCardsSummary } from '../../../utils/numbers'

const SummaryCards = ({ controlPanelData }) => {
  const classes = useStyles()

  const renderCards = controlPanelData?.map((item) => (
    <div className={classes.flexItem} key={item.id}>
      <SummaryCard
        product={item.type}
        measure={
          item.summary >= 0
            ? `${changeFormatNumbersCardsSummary(item.summary)} ${item.unit}`
            : '-'
        }
        color={getTextCardSummaryColor(item.type)}
      />
    </div>
  ))

  return (
    <Grid item xs={12}>
      <div className={classes.flexContainer}>{renderCards}</div>
    </Grid>
  )
}

export default SummaryCards
